import { useCallback, useEffect, useRef, useState } from 'react'
import { isSignedTemplateMediaEnabled, resolveTemplateMedia, signedMedia } from './signedMedia'

export interface UseSignedMediaResult {
  src: string | undefined
  onError: () => void
}

export function useSignedMedia(localPath: string | undefined): UseSignedMediaResult {
  const mapped = isSignedTemplateMediaEnabled() && localPath ? resolveTemplateMedia(localPath) : null
  const templateId = mapped?.templateId
  const key = mapped?.key

  const [src, setSrc] = useState<string | undefined>(() =>
    templateId && key ? undefined : localPath,
  )
  const requestSeqRef = useRef(0)

  useEffect(() => {
    requestSeqRef.current += 1
    if (!templateId || !key) {
      setSrc(localPath)
      return
    }
    const seq = requestSeqRef.current
    setSrc(undefined)
    void signedMedia.resolve(templateId, key).then((url) => {
      if (seq === requestSeqRef.current) setSrc(url ?? localPath)
    })
  }, [templateId, key, localPath])

  const onError = useCallback(() => {
    if (!templateId || !key) return
    if (!signedMedia.invalidate(templateId, key)) return
    const seq = requestSeqRef.current
    void signedMedia.resolve(templateId, key).then((url) => {
      if (seq === requestSeqRef.current) setSrc(url ?? localPath)
    })
  }, [templateId, key, localPath])

  return { src, onError }
}
